import Big from "big.js";
import { getRegionalConfig } from "../config";

export const formatDecimal = (str, val = 2) => {
  let strFormat = str.toString();
  strFormat = parseFloat(str).toFixed(val);
  return strFormat;
};

export const numberToDay = (day = 0) => {
  if (day === 0) return 7;
  return day;
};

export const formatMoney = (number = 0) => {
  const {
    number_of_decimals = 2,
    thousands_separator = ",",
    decimal_separator = "."
  } = getRegionalConfig();

  const minimumFractionDigits = Number(number_of_decimals);

  const normalizedNumber = normalizeNumericInput(number);
  let bigNumber = Big(normalizedNumber);

  if (minimumFractionDigits === 0) {
    bigNumber = Big(roundUpInteger(bigNumber, number_of_decimals));
  }

  let formattedNumber = bigNumber.toFixed(minimumFractionDigits);

  const parts = formattedNumber.split(".");
  let intPart = parts[0];
  let decimalPart = minimumFractionDigits > 0 ? `${parts.length > 1 ? parts[1] : ""}` : "";

  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator);

  if (decimalPart.length < minimumFractionDigits) {
    decimalPart = decimalPart.padEnd(minimumFractionDigits, "0");
  }

  formattedNumber = intPart + (decimalPart.length > 0 ? `${decimal_separator}${decimalPart}` : "");

  return formattedNumber;
};

export const roundUpInteger = (number, numberOfDecimals = 2) => {
  const bigNumber = Big(normalizeNumericInput(number));

  if (Number(numberOfDecimals) > 0) return bigNumber.toNumber();

  let integerPart = bigNumber.round(0, 0).toNumber();
  const decimalPart = bigNumber.minus(integerPart).toNumber();

  if (decimalPart >= 0.5) {
    integerPart += 1;
  }

  return integerPart;
};

const normalizeNumericInput = (value) => {
  if (value == null || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (typeof value === "string") {
    const cleaned = value.replace(/,/g, "").trim();
    const parsed = Number(cleaned);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatCurrencyTyping = (inputValue = '') => {
  const {
    number_of_decimals = 2,
    thousands_separator = ',',
    decimal_separator = '.'
  } = getRegionalConfig();

  const parts = inputValue.split(decimal_separator);

  parts[0] = parts[0].replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator);

  if (parts[1] !== undefined && number_of_decimals > 0) {
    parts[1] = parts[1].replace(/\D/g, '');
    return `${parts[0]}${decimal_separator}${parts[1].slice(0, number_of_decimals)}`;
  }

  return parts[0];
};

export const parseCurrencyToRaw = (formattedValue = '') => {
  const { decimal_separator = '.' } = getRegionalConfig();

  const parts = formattedValue.split(decimal_separator);

  let rawValue = parts[0].replace(/[,.' ']/g, '');

  if (parts[1] !== undefined) {
    rawValue = `${rawValue}.${parts[1]}`;
  }

  return rawValue.replace(/\s+/g, '');
};

export const sanitizeDecimalInput = (value = '') => {
  const sanitized = String(value).replace(/[^\d.]/g, '');
  const parts = sanitized.split('.');

  if (parts.length <= 1) return sanitized;

  return `${parts[0]}.${parts.slice(1).join('')}`;
};

export const sanitizeCurrencyRaw = (value = '') =>
  parseCurrencyToRaw(formatCurrencyTyping(String(value)));

export const sanitizeIntegerInput = (value = '') => String(value).replace(/\D/g, '');
